import { Columns3 } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
	DropdownMenu,
	DropdownMenuCheckboxItem,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

interface ColumnsMenuProps {
	columns: { key: string; label: string }[]
	isVisible: (key: string) => boolean
	onToggle: (key: string) => void
	onReset: () => void
	hasHidden: boolean
}

/** Menu para escolher quais colunas da tabela aparecem (a escolha é salva por quem usa o hook). */
export function ColumnsMenu({
	columns,
	isVisible,
	onToggle,
	onReset,
	hasHidden,
}: ColumnsMenuProps) {
	const { t } = useTranslation()

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button
					type="button"
					variant="outline"
					className="w-auto shrink-0 gap-2"
				>
					<Columns3 className="size-4" />
					<span>{t('common.columns')}</span>
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent
				align="end"
				className="max-h-(--radix-dropdown-menu-content-available-height) overflow-y-auto"
			>
				{columns.map((column) => (
					<DropdownMenuCheckboxItem
						key={column.key}
						checked={isVisible(column.key)}
						onCheckedChange={() => onToggle(column.key)}
						onSelect={(event) => event.preventDefault()}
					>
						{column.label}
					</DropdownMenuCheckboxItem>
				))}
				{hasHidden && (
					<>
						<DropdownMenuSeparator />
						<DropdownMenuItem onSelect={onReset}>
							{t('common.resetColumns')}
						</DropdownMenuItem>
					</>
				)}
			</DropdownMenuContent>
		</DropdownMenu>
	)
}
